import Nullstack from 'nullstack';
export default function IconWiperWash({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wiper-wash",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "20",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "6"
  }), "   ", Nullstack.element("path", {
    d: "M4 6a4 4 0 0 1 .4 -1.8"
  }), "   ", Nullstack.element("path", {
    d: "M7 2.1a4 4 0 0 1 2 0"
  }), "   ", Nullstack.element("path", {
    d: "M12 6a4 4 0 0 0 -.4 -1.8"
  }), "   ", Nullstack.element("path", {
    d: "M12 6a4 4 0 0 1 .4 -1.8"
  }), "   ", Nullstack.element("path", {
    d: "M15 2.1a4 4 0 0 1 2 0"
  }), "   ", Nullstack.element("path", {
    d: "M20 6a4 4 0 0 0 -.4 -1.8"
  }), " ");
}